import { styled } from '@mui/material';
import React from 'react';
import { ProductRewardSearchResult } from '../../types';
import { BrandclubProductCard } from '../components/BrandclubProductCard';
import { BaseComponentPropsType } from '../type';
import BrandclubLoading from '../components/BrandclubLoading';
import { ProductGrid } from './SearchResultsStyles';

type ProductGridProps = {
  loading: boolean;
  products: ProductRewardSearchResult[];
  LinkComponent: BaseComponentPropsType['LinkComponent'];
  containerWidthOverride?: boolean;
  onShareClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>, product?: ProductRewardSearchResult) => void;
  children?: React.ReactNode;
};

const Container = styled('div')({});
const SearchProductGrid = ({
  loading,
  products,
  LinkComponent,
  containerWidthOverride,
  onShareClick,
  children,
}: ProductGridProps) => {
  return (
    <Container>
      {loading ? (
        <BrandclubLoading type="productGrid"></BrandclubLoading>
      ) : (
        <ProductGrid className="grid" containerWidthOverride={containerWidthOverride}>
          {children}
          {products.map((product, idx) => {
            return (
              <BrandclubProductCard
                className="fullsize_responsive"
                LinkComponent={LinkComponent}
                onShareClick={(e) => onShareClick(e, product)}
                key={idx}
                product={product}
              ></BrandclubProductCard>
            );
          })}
        </ProductGrid>
      )}
    </Container>
  );
};

export default SearchProductGrid;
